<template>
  <section id="setup" class="container">
    <section
      v-if="step === 1"
      id="setup-content"
      class="box padding w-buttons install step1"
    >
      <div class="w100 txt-center">
        <h1>Obrigado pelo cadastro, e vamos te ajudar a escalar!</h1>
        <p class="margin-top-m">
          Vamos precisar que você siga este fluxo para coletar algumas informações e otimizar em muito sua experiência na Lucrei Hoje !
        </p>
      </div>
      <div class="flex column middle center margin-top-l">
        <form>
          <!-- Modelo da Operação -->
          <div class="flex-1 w100">
            <label>
              Qual modelo da sua operação?
            </label>
            <div class="flex flex-1 center margin-top-l">
              <div 
                @click="firstType('DROPSHIPPING')"
                class="button primary"
                :class="{ active: info.operation === 'DROPSHIPPING' }"
              >
                <b>DROPSHIPPING</b>
              </div>
              <div
                @click="firstType('PLR')"
                class="button primary"
                style="margin-left: 10px"
                :class="{ active: info.operation === 'PLR' }"
              >
                <b>PLR</b>
              </div>
              <div
                @click="firstType('E-COMMERCE')"
                class="button primary"
                style="margin-left: 10px"
                :class="{ active: info.operation === 'E-COMMERCE' }"
              >
                <b>E-COMMERCE</b>
              </div>
              <div
                @click="firstType('SAAS')"
                class="button primary"
                style="margin-left: 10px"
                :class="{ active: info.operation === 'SAAS' }"
              >
                <b>SAAS</b>
              </div>
              <div
                @click="firstType('OUTROS')"
                class="button primary"
                style="margin-left: 10px"
                :class="{ active: info.operation === 'OUTROS' }"
              >
                <b>OUTROS</b>
              </div>
            </div>
          </div>
          
          <!-- Investimento em MKT -->
          <div class="flex-1 margin-top-l w100">
            <label>Valor gasto mensal em Marketing Pago?</label>
            <money v-model="info.marketing" v-bind="money"></money>
          </div>
          
          <!-- Faturamento Mensal -->
          <div class="flex-1 margin-top-l w100">
            <label>Faturamento da sua operação mensal?</label>
            <money v-model="info.faturamento" v-bind="money"></money>
          </div>
        </form>
      </div>
      <div class="buttons flex center">
        <button class="button primary medium" @click="step++">
          Apenas mais 1 passo
        </button>
      </div>
    </section>

    <section
      v-if="step === 2"
      id="setup-content"
      class="box padding w-buttons install step1"
    >
      <div class="w100 txt-center">
        <p>
          Precisamos saber apenas mais algumas informações.
        </p>
      </div>
      <div class="flex column middle center margin-top-l">

        <!-- Tempo operação -->
        <div class="flex-1 w100">
          <label>
            Quanto tempo tem sua operação?
          </label>
          <div class="flex row w100 margin-top-l">
            <div 
              @click="secondaryType('0-1 mês')"
              class="button primary flex-1"
              :class="{ active: info.time === '0-1 mês' }"
            >
              <b>0-1 mês</b>
            </div>
            <div
              @click="secondaryType('1-6 meses')"
              class="button primary flex-1" 
              style="margin-left: 10px"
              :class="{ active: info.time === '1-6 meses' }"
            >
              <b>1-6 meses</b>
            </div>
            <div
              @click="secondaryType('6-12 meses')"
              class="button primary flex-1"
              style="margin-left: 10px"
              :class="{ active: info.time === '6-12 meses' }"
            >
              <b>6-12 meses</b>
            </div>
            <div
              @click="secondaryType('12-24 meses')"
              class="button primary flex-1"
              style="margin-left: 10px"
              :class="{ active: info.time === '12-24 meses' }"
            >
              <b>12-24 meses</b>
            </div>
            <div
              @click="secondaryType('24+ meses')"
              class="button primary flex-1"
              style="margin-left: 10px"
              :class="{ active: info.time === '24+ meses' }"
            >
              <b>24+ meses</b>
            </div>
            
          </div>
        </div>

        <!-- Origem -->
        <div class="flex-1 w100">
          <div
              class="form-field flex-1 w100 group-input margin-top-m"
            >
              <label>Onde conheceu a ferramenta?</label>
              <input class="input" type="text" v-model="info.source" />
          </div>
        </div>

        <!-- Dificuldade -->
        <div class="flex-1 w100">
          <div
              class="form-field flex-1 w100 group-input margin-top-m"
            >
              <label>Qual sua maior dificuldade hoje?</label>
              <input class="input" type="text" v-model="info.dificuldade" />
          </div>
        </div>
        
        <!-- O que espera -->
        <div class="flex-1 w100">
          <div
              class="form-field flex-1 w100 group-input margin-top-m"
            >
              <label>O que espera em relação a Lucrei Hoje?</label>
              <input class="input" type="text" v-model="info.lucreihoje" />
          </div>
        </div>
      </div>
      <div class="buttons flex center">
        <button v-if="false" class="button secondary medium" @click="step--">
          Voltar
        </button>
        <button class="button primary medium" style="margin-left:16px" @click="updateAccount()">
          Conheça seu plano
        </button>
      </div>
    </section>
  </section>
</template>

<script>
import { mapState } from "vuex";
import { Money } from 'v-money'

import { Account, updateAccount } from "@/services/account";

export default {
  name: "SelectPlan",
  props: {
    msg: String,
  },
  components: {
    Money
  },
  data() {
    return {
      step: 1,
      info: {
        operation: '',
        time: '',
        marketing: 0,
        faturamento: 0,
        lucreihoje: '',
        source: '',
        dificuldade: '',
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      }
    };
  },
  mounted() {
    this.getAccountInfo();
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
  },
  methods: {
    firstType(typeAccount) {
      this.info.operation = typeAccount;
    },
    secondaryType(secondaryInfo) {
      this.info.time = secondaryInfo;
    },
    getAccountInfo() {
      Account().then((result) => {
        this.$store.dispatch("setAccount", result);
      });
    },
    updateAccount() {
      let url = `https://lucreihoje.com.br/escolha-seu-plano.html?freemium=true&email=${this.account && this.account.email}&phone=${this.account && this.account.phone}`
      
      let params = {
        business_type: this.info.operation,
        marketing: this.info.marketing,
        faturamento: this.info.faturamento,
        time_business: this.info.time,
        source: this.info.source,
        dificuldade: this.info.dificuldade,
        watch_await: this.info.lucreihoje,
      };

      updateAccount(params)
        .then(() => {
          document.location.href = url
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao salvar informações",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
#setup {
  margin-top: 100px;
  label {
    font-weight: 800;
  }
}

.button.primary  {
  &.active {
    background: #000;
  }
}
</style>
